<template>
  <div class="container">

    <div class="container__aside">
      <!--LOGO-->
      <div class="logo">
        <el-avatar :src="logo" class="logo__image"  />
        {{$config.systemName}}
      </div>

      <!--MENU-->
      <el-menu :default-active="$route.path" router>
        <template v-for="route in routes">
          <template v-if="route.meta.hideInMenu !== true">
            <el-menu-item :key="route.meta.index" :index="route.path">
              <span slot="title">{{route.meta.title}}</span>
            </el-menu-item>
          </template>
        </template>
      </el-menu>

    </div>

    <div class="container__main">
      <header class="container__header">
        <div />
        <div class="admin">
          <el-popover placement="bottom" trigger="hover">
            <div class="admin__info">
              <el-descriptions title="个人信息" :column="2">
                <el-descriptions-item label="账号">{{admin.phone}}</el-descriptions-item>
              </el-descriptions>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-button type="primary" round size="small" @click="logout" style="width: 100%">安全退出</el-button>
                </el-col>
              </el-row>
            </div>

            <div slot="reference">
              <el-avatar :src="admin._avatar" :size="32" class="admin__avatar" v-if="admin.avatar !== undefined" />
              <el-link type="info" :underline="false">{{admin.name}}</el-link>
            </div>
          </el-popover>
        </div>
      </header>
      <router-view />
      <footer class="container__footer">
        Copyright © 2023-{{currentYear}} MANBA {{$config.version}}. All Rights Reserved.
      </footer>
    </div>
  
  </div>
</template>
<script>
import routes from '@/router/routes'
import logo from '@/assets/image/logo.png'
import { readme } from '@/api/admin'
export default {
  name: 'Container',
  data() {
    return {
      logo,
      routes,
      admin: {}
    }
  },
  mounted() {
    readme().then(res => {
      this.admin = res.data.data
    })
  },
	computed: {
		currentYear() {
			return new Date().getFullYear()                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
		}
	},
  methods: {
    logout() {
      sessionStorage.removeItem(this.$config.tokenName)
      this.$router.push({path: this.$config.indexURL})
    }
  }
}
</script>
<style lang="less" scoped>
@import "@/assets/style/color-var.less";
.container {
  display: flex;
  padding: 48px;

  &__aside {
		width: 232px;
		flex-shrink: 0
	}

	&__header {
		margin-bottom: 20px;
		display: flex;
		justify-content: space-between;
		background-color: #FFF;
		padding: 0 20px;
		height: 52px;
		line-height: 52px
	}

	&__main {
		margin-left: 48px;
		width: 0;
    flex: auto
	}

	&__footer {
		margin-top: 20px;
		text-align: center;
		color: @text-color--c
	}
}

.logo {
	margin-bottom: 20px;
	display: flex;
	height: 40px;
	line-height: 40px;
	font-size: 22px;
	font-family: '微软雅黑';

	&__image {
		margin-right: 8px;
		width: 40px;
		height: 40px;
		border-radius: 50%
	}
}
.admin {
	display: flex;
	align-items: center;

  &__avatar {
		margin-right: 8px;
		vertical-align: middle;
		cursor: pointer
  }

	&__info {
		width: 320px
	}
}
</style>